import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import videoImg from "@baseImg/videos/video-clients.webp";
import VideoModal from "@components/base/Modal/VideoModal/VideoModal";

const BG = {
	blockIntro: {
		top: {
			blockTitle: 'Успехът говори сам',
			blockDesc: 'Над 200 000 уебсайта вече ни се довериха. Ето какво споделят част от клиентите ни.',
			titleSize: '',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: '',
			buttonModalParams: {}
		},
		bottom: {}
	},
	blockContent:
	  {
		  title: 'Успехът говори сам',
		  img: videoImg,
		  platform: 'wistia',
		  videoId: 'lc8i1dl5ww',
		  VideoModal: VideoModal,
		  modalParams: {
			  data: '#data#',
			  color: '#color#',
			  platform: '#platform#',
			  key: '#key#'
		  },
		  autoPlay: true,
		  uploadDate: "2026-02-04T09:34:43+00:00",
		  watchText: 'Гледай в YouTube'
	  }
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockIntro: {
		top: {
			blockTitle: 'Success speaks for itself',
			blockDesc: 'Over 200,000 websites already rely on us. Here’s what some of our clients have to say.',
			titleSize: '',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: '',
			buttonModalParams: {}
		},
		bottom: {}
	},
	blockContent:
	  {
		  title: 'Success speaks for itself',
		  img: videoImg,
		  platform: 'wistia',
		  videoId: '',
		  VideoModal: VideoModal,
		  modalParams: {
			  data: '#data#',
			  color: '#color#',
			  platform: '#platform#',
			  key: '#key#'
		  },
		  autoPlay: true,
		  uploadDate: "2026-02-04T09:34:43+00:00",
		  watchText: 'Гледай в YouTube'
	  }
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];